$(function() {

	$('.year').html(new Date().getFullYear());

	$('.header-slider').slick({
		arrows: false,
		dots: true,
		speed: 1000
	});

	$('.header-arrow.prev').on('click', function(e) {
		e.preventDefault();

		$('.header-slider').slick('slickPrev');
	});

	$('.header-arrow.next').on('click', function(e) {
		e.preventDefault();

		$('.header-slider').slick('slickNext');
	});




	$('.top-search-wrap .icon').on('click', function(e) {
		e.preventDefault();

		$('.header-search-form').fadeIn();
	});

	$(document).mouseup(function(e) { 
		var div = $('.top-search-wrap');
		if (!div.is(e.target) && div.has(e.target).length === 0) {
			$('.header-search-form').fadeOut();
		}
	});





	var instBlockMax = $('.inst-wrap').innerWidth() - $(window).width();

	if ($(window).width() > 960) {
		$('.inst-wrap').on('mousedown', function(e) {
			var instOffset = $('.inst-wrap').css('left');
			var startDragPoint = e.clientX;
			var newOffset;

			$(document).on('mousemove', function(e) {
				$('.inst-wrap-overlay').show();
				newOffset = startDragPoint - e.pageX;
				var newOffsetVal = parseInt(instOffset) - newOffset;

				if (newOffsetVal <= 0 && newOffsetVal > (-(instBlockMax))) {
					$('.inst-wrap').css('left', newOffsetVal);
				}									
			});

			$(document).on('mouseup', function() {
				$(this).off('mousemove mouseup');
				$('.inst-wrap-overlay').hide();
			});

			return false;
		});
	}






	$('.aisde-tab h4').on('click', function(e) {
		e.preventDefault();

		$(this).parent().toggleClass('active');
		$(this).next().slideToggle();
	});




	if ($(window).width() > 960) {
		if ($('.customer-reviews-item').length < 4) {
			$('.customer-reviews-arrows').hide();
		}
	} else {
		if ($('.customer-reviews-item').length < 2) {
			$('.customer-reviews-arrows').hide();
		}
	}

// 	$('.customer-reviews-slider').slick({
// 		slidesToShow: 3,
// 		arrows: false,
// 		infinite: false,
// 		responsive: [{
// 			breakpoint: 960,
// 			settings: {
// 				slidesToShow: 2
// 			}
// 		}, {
// 			breakpoint: 750,
// 			settings: {
// 				slidesToShow: 1
// 			}
// 		}]
// 	});

// 	$('.customer-reviews-arrows .arrow.prev').on('click', function(e) {
// 		e.preventDefault();

// 		$('.customer-reviews-slider').slick('slickPrev');
// 	});

// 	$('.customer-reviews-arrows .arrow.next').on('click', function(e) {
// 		e.preventDefault();

// 		$('.customer-reviews-slider').slick('slickNext');
// 	});
 






	if ($(window).width() > 960) {
		var faqAmount = $('.faq-item').length;
		var faqLeftAmount = Math.ceil($('.faq-item').length / 2);

		for (var i = 0; i < faqLeftAmount; i++) {
			$('.faq-item').eq(i).appendTo('.faq-left');
		}

		for (var i = faqLeftAmount; i < faqAmount; i++) {
			$('.faq-item').eq(i).appendTo('.faq-right');
		}		
	}

	$('.faq-item .ques').on('click', function(e) {
		$(this).toggleClass('active');

		$(this).next().slideToggle();		
	});





	$('.product-small-slider-item').on('click', function(e) {
		e.preventDefault();

		$(this).addClass('active').siblings().removeClass('active');
		$('.product-big-slider-item').eq($(this).index()).addClass('active').siblings().removeClass('active');
	});





	$('.big-blog-button a').on('click', function(e) {
		e.preventDefault();

		$(this).toggleClass('active');

		if ($(this).hasClass('active')) {
			$('.big-blog-item').addClass('active');
			$(this).html('Hide');
		} else {
			$('.big-blog-item').removeClass('active');
			$(this).html('Read all articles');
		}
	});
  
  
    if ($('.big-blog-item').length <= 4) {
		$('.big-blog-button').hide();
    }
  
  
  
  
  
    $('form.cart-form').on('submit', function(e) {
      if (!$(this).find('input[name="agree"]').prop('checked')) {
          e.preventDefault();
      }
    });
  
  
  
  
  
 	$('.product-small-slider-item').first().addClass('active');
  	$('.product-big-slider-item').first().addClass('active');
	
  

  
  
  	if ($('.product-right .select select.product-variants option').first().html() == 'Default Title') {
    	$('.product-right .weight').addClass('hidden');
    }
  
  
  
  
  	$('.product-right .qty-wrap a.faq').on('click', function(e) {
      	e.preventDefault();
      	
      	$('html, body').animate({
          	scrollTop: $('section.faq-section').offset().top
        }, 1000);
    });
  
  
  
  
  	$('ul.mob-menu > li.have-submenu > a').on('click', function(e) {
    	e.preventDefault();
      
      	$(this).next().slideToggle();
      	$(this).parent().toggleClass('active');
    });
  
  
  
  
  	$('.burger').on('click', function(e) {
    	e.preventDefault();
      
      	$(this).toggleClass('active');
      	$('section.mob-menu-section').slideToggle();
      	$('body').toggleClass('hidden');
    });
  
  
  
  
  
  	if ($('section.contacts-section').length > 0) {
      	var coords = $('.contacts-map').attr('data-coords').replace( /\s/g, "").split(',');
      	var coord1 = coords[0];
      	var coord2 = coords[1];
      
    	$('#map').gmap3({
            center: [coord1, coord2],
            zoom: 15
        }).marker([
            {position:[coord1, coord2]}
        ]);
    }
  
  
  
  	$('.thanks-overlay, .thanks-modal .close').on('click', function(e) {
    	e.preventDefault();
      
      	$('.thanks-overlay, .thanks-modal').fadeOut();
    });
  
  
//     if ($('.about-img-wrap img').length < 2) {
// 		$(this).parent().addClass('center');
//     }
  
    $('.about-img-wrap').each(function() {
        if ($(this).find('img').length < 2) {
			$(this).addClass('center');
        }
    });
  
  
  
  
    $('.mob-show-aside a.button').on('click', function(e) {
        e.preventDefault();

        $(this).parent().toggleClass('active');

        if ($(this).parent().hasClass('active')) {
            $(this).html('Hide Filters');
            $('aside').slideDown(500);
        } else {
            $(this).html('Show Filters');
            $('aside').slideUp(500);

            $('html, body').animate({
                scrollTop: 0
            }, 500);
        }
    });
  
  
  
  
  	var cartCommonCost = 0;
  
    $(document).on('click', '.cart-left .js--qty-adjuster.js--add', function() {
      	cartCommonCost = 0;        
        
		var thisCost = $(this).parents('.qty').attr('data-item-price');
      	var thisCost1 = parseFloat(thisCost.replace('$', ''));
      
      	var thisPrice = (thisCost1 * parseInt($(this).parent('.js-qty').find('.js--num').val())).toFixed(2);
      
      	$(this).parents('.cart-item').find('.price').html('$' + thisPrice);
      
      	$('.cart-item').each(function() {
        	var cartItemPrice = $(this).find('.price').html();          	
          	var cartItemPrice1 = cartItemPrice.replace(',', '');
          	var cartItemPrice2 = parseFloat(cartItemPrice1.replace('$', ''));
          
          	cartCommonCost += cartItemPrice2;          	
        });
      
      	$('.cart-right .total').html('$' + cartCommonCost.toFixed(2));
    });
  
  	$(document).on('click', '.cart-left .js--qty-adjuster.js--minus', function() {
      	cartCommonCost = 0; 
      	
		var thisCost = $(this).parents('.qty').attr('data-item-price');
      	var thisCost1 = parseFloat(thisCost.replace('$', ''));
      
      	var thisPrice = (thisCost1 * parseInt($(this).parent('.js-qty').find('.js--num').val())).toFixed(2);
      
      	$(this).parents('.cart-item').find('.price').html('$' + thisPrice);
      
      	$('.cart-item').each(function() {
        	var cartItemPrice = $(this).find('.price').html();          	
          	var cartItemPrice1 = cartItemPrice.replace(',', '');
          	var cartItemPrice2 = parseFloat(cartItemPrice1.replace('$', ''));
          
          	cartCommonCost += cartItemPrice2;          	
        });
      
      	$('.cart-right .total').html('$' + cartCommonCost.toFixed(2));
    });





});


    
   
